// extracted by mini-css-extract-plugin
export default {"p_tye":"_4a56e7cfee","slcted":"bdfebd0e84","slc_color":"e9b5961fb6","item_p":"_88c2bb8aed","r0":"_63caceaefb"};